import { render, staticRenderFns } from "./ModificarProductoVenta.vue?vue&type=template&id=574c472c&scoped=true&"
import script from "./ModificarProductoVenta.vue?vue&type=script&lang=js&"
export * from "./ModificarProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c472c",
  null
  
)

export default component.exports